import axios from "axios";

import { getHeader } from "../headers";

// ===================================================================================
//  GET NEWS PAGINATION
// ===================================================================================
export const newsPaginationIsLoading = () => {
	return {
		type: "NEWS_PAGINATION_IS_LOADING"
	};
};

export const newsPaginationHasError = err => {
	return {
		type: "NEWS_PAGINATION_HAS_ERROR",
		hasErrored: true,
		error: err
	};
};

export const newsPaginationSuccess = data => {
	return {
		type: "NEWS_PAGINATION_SUCCESS",
		data
	};
};

export function getNewsPagination(pg = 0, max = 10) {
	return dispatch => {
		dispatch(newsPaginationIsLoading());

		// Add id of record to find if passed
		const endPoint = "news/paginated";

		const params = { language: process.env.REACT_APP_LANGUAGE, pg, max };

		return axios
			.get(process.env.REACT_APP_API_URL + endPoint, {
				headers: getHeader(),
				params
			})
			.then(response => {
				if (response.data.status && response.data.status !== 200) {
					dispatch(newsPaginationHasError(response.data.errors));
				} else {
					return dispatch(newsPaginationSuccess(response));
				}
			})
			.catch(err => {
				dispatch(newsPaginationHasError(err.response.data.message));
			});
	};
}

// ===================================================================================
//  CLEAR
// ===================================================================================
export const clearNewsPagination = () => {
	return {
		type: "NEWS_PAGINATION_CLEAR"
	};
};



// WEBPACK FOOTER //
// ./src/store/actions/newsPagination.js